/* eslint-disable import/prefer-default-export */
import React, { useState } from 'react';
import Icon from 'antd/lib/icon';

// No static import of @react-pdf/renderer or ReportPDF -
// they are loaded dynamically on first download click

function mapRecordToPdfData(record) {
  return {
    ...record,
    customerData: record.customer,
    devicesData: record.devices.map(d => d.device),
    devices: record.devices.map(d => ({
      ...d,
      device: d.device._id,
    })),
  };
}

async function generateAndDownloadPdf(data, fileName) {
  // eslint-disable-next-line max-len
  const [{ pdf }, { default: ReportDocument }] = await Promise.all([
    import('@react-pdf/renderer'),
    import('../../components/PrintPDF/ReportPDF'),
  ]);
  const blob = await pdf(
    React.createElement(ReportDocument, { data })
  ).toBlob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName || `${data.name}.pdf`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

// Component for download icon in archive table columns
export function ColumnDownloadReport({ record }) {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const data = mapRecordToPdfData(record);
      await generateAndDownloadPdf(data);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Failed to generate PDF:', error);
    }
    setLoading(false);
  };

  return (
    <Icon
      type={loading ? 'loading' : 'download'}
      style={{ cursor: 'pointer', fontSize: '16px' }}
      onClick={handleClick}
    />
  );
}

function DownloadReportButton({ actionProps, action }) {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (loading) return;
    setLoading(true);
    try {
      await generateAndDownloadPdf(actionProps.data);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Failed to generate PDF:', error);
    }
    setLoading(false);
  };

  return (
    // eslint-disable-next-line max-len
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <span onClick={handleClick}>
      {action.renderAction({
        ...actionProps,
        ...(loading ? { title: 'Pripremam...', disabled: true } : {}),
      })}
    </span>
  );
}

export const actionDownloadReport = ['Action', {
  name: 'download-report',
  title: 'Preuzmi',
  ghost: true,
  icon: 'download',
  renderAction: (props, action) => (
    <DownloadReportButton actionProps={props} action={action} />
  ),
}];
